/**
 * SessionExpiredDialog Component
 *
 * Alert dialog when the session has fully expired, redirecting
 * the user back to the moderation queue page.
 */

import { Dialog } from '@soteria/design-system-ve';
import type { ReactElement } from 'react';

interface SessionExpiredDialogProps {
  /** Whether the dialog is visible */
  isOpen: boolean;
  /** Handler to acknowledge and navigate back */
  onReturn: () => void;
}

/** Alert dialog shown when the moderation session TTL has fully expired */
export function SessionExpiredDialog({ isOpen, onReturn }: SessionExpiredDialogProps): ReactElement | null {
  if (!isOpen) return null;

  return (
    <Dialog
      isOpen
      description="Your moderation session has expired. You will be returned to the moderation queue."
      primaryAction={{
        label: 'Return to Queue',
        onClick: onReturn,
        variant: 'primary',
      }}
      title="Session Expired"
      onClose={onReturn}
    >
      {null}
    </Dialog>
  );
}
